import { useState } from 'react';

export default function CookieConsent({ navigate }) {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookie_consent'));

  function accept() {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: 'var(--card)', borderTop: '1px solid var(--border)',
      padding: '16px 24px',
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 16,
    }}>
      <p style={{ fontSize: 13, color: 'var(--muted)', margin: 0, maxWidth: 600 }}>
        We use only essential cookies to keep you signed in. No tracking or advertising cookies.{' '}
        <span
          style={{ color: 'var(--accent)', cursor: 'pointer' }}
          onClick={() => navigate('cookies')}
        >
          Learn more
        </span>
      </p>
      <button
        onClick={accept}
        style={{
          padding: '8px 24px', borderRadius: 'var(--radius-xs)', fontSize: 13,
          fontWeight: 600, border: 'none', cursor: 'pointer',
          background: 'linear-gradient(135deg, var(--accent), #6558d4)', color: '#fff',
        }}
      >
        Got it
      </button>
    </div>
  );
}
